module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("hdalN"))).then(() => module.bundle.root('ikE14'));